import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormSectionWrapper from "../../../Components/ProForms/FormSectionWrapper";
import ProFormsLayout from "../../../Components/ProForms/ProFormsLayout";
import { useForm } from "react-hook-form";
import { STAUTES } from "../../../../utils/constant";
import ProTextInput from "../../../Components/Inputs/TextField";
import ProSelectField from "../../../Components/Inputs/SelectField";
import ProMobileField from "../../../Components/Inputs/MobileField";
import ProEmailField from "../../../Components/Inputs/EmailField";
import ProDateField from "../../../Components/Inputs/DateField";
import ProCurrencyField from "../../../Components/Inputs/CurrencyField";
import ProFileUploadField from "../../../Components/Inputs/FileUploadField";
import ProSSNField from "../../../Components/Inputs/SSNField";
import ProMultiSelectSelectField from "../../../Components/Inputs/MultiSelectField";
import InputWrapper from "../../../Components/Inputs/InputWrapper";
import ProCheckbox from "../../../Components/Inputs/CheckboxField";
import {
  changeMode,
  changeModeForField,
  prepareDefaultValues,
  prepareInitialConfig,
  employeeProfileFormName,
  convertFileToBase64Model,
  formatPayloadDate,
  fieldTruePermission,
  isDateApprenticeshipBeginsInRange
} from "../../../../utils/formHelper";
import { Box } from "@mui/material";
import {
  GET_ALL_LANGUAGE_TYPES,
  GET_ALL_MANAGER_TYPES,
  GET_ALL_NOTIFICATION_TYPES,
  GET_ALL_EMPLOYEE_STATUS_TYPES,
  GET_ALL_EMPLOYEE_TERM,
  GET_ALL_FRINGE_PAYMENT_METHOD,
  GET_ALL_ETHNICITY_TYPES,
  GET_ALL_VETERAN_STATUS_TYPES,
  GET_ALL_RACE_TYPES,
  GET_ALL_EDUCATION_LEVEL_TYPES,
  GET_ALL_DISABILITY_TYPES,
  GET_ALL_EMPLOYEES_V2, // V2 endpoint for adding employees
  SEND_APPRENTICE_APPLICATION_DOCUMENT,
  GET_CLIENT_FRINGE_BENEFITS
} from "../../../../utils/services/apiPath";
import {
  GET_ALL_CAREER_CONNECTION_TYPES,
  GET_ALL_APPRENTICE_STATUS_TYPES,
  RAP_INFOS_DROPDOWNS,
  RAP_RTI_DROPDOWN
} from "../../../../utils/services/apiPath";
import { errorToast, successToast } from "../../../../utils/toastHelper";
import { postApi, getApi } from "../../../../utils/services";
import Loading from "../../../Components/Loading";
import { defaultDropdownConfig, employmentStatusOptions, sexOptions, transFormModalData } from "../../../../utils/dropdownHelper";
import { employeesProfilePermissionSelector, employeesPermissionSelector } from "../../../store/features/permissions/permissionsSlice";
import usePermission from "../../../../utils/customHooks/usePermission";
import ZipField from "../../../Components/Inputs/ZipField";
import { useSelector } from "react-redux";
import { userSelector } from "../../../store/features/auth/authSlice";
import { EmployeeProfileFormConfig } from "../EmployeeData";
import ToggleField from "../../../Components/Inputs/ToggleButton";
import { fringeBenefitTypes } from "../../../Constants/DropdownTypes";

const isOptionNotSelected = (opt, selectedList) =>
  !(Array.isArray(selectedList) && selectedList.some(item => item.value === opt.value));

export default function AddForm() {
  const user = useSelector(userSelector);
  const isUserOnRAP360Program = user?.apprenticeManagementType === "Apprenticeship 360";
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(EmployeeProfileFormConfig));
  const [employeeProfileData, setEmployeeProfileData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [languageType, setLanguageType] = useState([]);
  const [notificationType, setNotificationType] = useState([]);
  const [employeeStausType, setEmployeeStausType] = useState([]);
  const [employeeTermType, setEmployeeTermType] = useState([]);
  const [managerType, setManagerType] = useState([]);
  const [fringePaymentMethod, setFringePaymentMethod] = useState([]);
  const [ethnicity, setEthnicity] = useState([]);
  const [veteranStatus, setVeteranStatus] = useState([]);
  const [race, setRace] = useState([]);
  const [educationLevel, setEducationLevel] = useState([]);
  const [disability, setDisability] = useState([]);
  const [rapPrograms, setRapPrograms] = useState([]);
  const [careerConnections, setCareerConnections] = useState([]);
  const [apprenticeStatuses, setApprenticeStatuses] = useState([]);
  const [rtiOptions, setRtiOptions] = useState([]);
  const [healthInsuranceOptions, setHealthInsuranceOptions] = useState([]);
  const [retirementPensionOptions, setRetirementPensionOptions] = useState([]);
  const [fringeBenefitCheckbox, setFringeBenefitCheckbox] = useState([]);
  const [fringeBenefitDropdowns, setFringeBenefitDropdowns] = useState([]);

  const [status, setStatus] = useState(STAUTES.IDLE);
  const { handleSubmit, control, setValue, watch, register } = useForm({ defaultValues: prepareDefaultValues(EmployeeProfileFormConfig), mode: "onChange" });
  const isEditModeOn = useMemo(() => Object.values(formConfig).some(({ mode }) => mode === "edit"), [formConfig]);
  const {
    "Basic Information": employeeBasicInfo,
    "Apprentice Information": employeeApprenticeInfo,
    "Address Information": employeeAddressInfo,
    "Mailing Address Inforamtion": employeeMailingAddressInfo,
    "Additional Information": employeeAdditionalInfo
  } = usePermission(employeesProfilePermissionSelector, employeeProfileFormName);
  const { subModulePermissions } = useSelector(employeesPermissionSelector);
  const profilePermission = subModulePermissions?.EMPLOYEES_PROFILE?.canView;
  const [isSaving, setIsSaving] = useState(false);
  const employeeType = watch("employeeTypeId");
  const healthInsurance = watch("healthInsuranceId");
  const retirementPension = watch("retirementPensionId");
  const isUnion = watch("isUnion");

  const navigate = useNavigate();
  const { id } = useParams();
  const backAction = () => navigate("/employees");

  const onEdit = () => setFormConfig(changeMode("edit"));

  const onCancel = () => navigate("/employees");

  const handleReadValueClick = name => setFormConfig(changeModeForField(name, "edit"));

  const sendApprenticeApplicationDocument = async (employeeGuid, email) => {
    const { error } = await postApi(`${SEND_APPRENTICE_APPLICATION_DOCUMENT}?employeeGuid=${employeeGuid}`);
    if (error) return errorToast(error);
    successToast(`An email of the onboarding document was sent to ${email}.`);
  };

  const onSubmit = async values => {
        // Date Apprenticeship Begins range validation
        if (values.dateApprenticeshipBegins && !isDateApprenticeshipBeginsInRange(values.dateApprenticeshipBegins)) {
          return errorToast("The Date Apprenticeship Begins must be within the allowed range — no earlier than 5 years before today and no later than 20 years after today.");
        }
    const employeeFringeBenefit = convertToEmployeeFringeBenefitPayload();
    if (isSaving) return;
    setIsSaving(true);
    setStatus(STAUTES.LOADING);

    try {
      const base64ProfilePicture = await convertFileToBase64Model(values.profilePictureFile);
      if (employeeType === 4) {
        values.apprenticeProspectStatusTypeId = 1;
      }

      values.isApprentice = employeeType === 1 || employeeType === 4;

      if (values.fringeRateAmount === undefined || values.fringeRateAmount === "") {
        values.fringeRateAmount = null;
      }
      const { retirementPensionId, healthInsuranceId, ...payloadValues } = values;
      const payload = {
        ...payloadValues,
        last4ofSSN: values.last4ofSSN,
        raceTypeId: values.raceTypeId?.map(({ value }) => value) || null,
        veteranStatusTypeId: values.veteranStatusTypeId?.map(({ value }) => value) || null,
        invitationVerificationCode: null,
        managerId: values.manager,
        languageTypeId: values.languageType,
        notificationTypeId: values.notificationType,
        fringePaymentMethodTypeId: values.fringePaymentMethodType,
        birthDate: formatPayloadDate(values.birthDate),
        startDate: formatPayloadDate(values.startDate),
        endDate: formatPayloadDate(values.endDate),
        dateApprenticeshipBegins: formatPayloadDate(values.dateApprenticeshipBegins),
        profileMediaModel: base64ProfilePicture || null,
        profilePicture: base64ProfilePicture?.base64String || null,
        employeeId: null,
        employeeFringeBenefit: employeeFringeBenefit
      };

      // Use V2 API endpoint with optional portalType parameter
      const response = await postApi(`${GET_ALL_EMPLOYEES_V2}?portalType=1`, payload); // portalType=1 for Admin/Client Portal

      setIsSaving(false);
      setStatus(STAUTES.IDLE);

      if(response?.error){
        return errorToast(typeof response.error === "string" ? response.error : "Failed to add employee");
      }

      // Handle both wrapped and unwrapped responses
      const employee = response?.data || response;

      if (!employee?.employeeId) {
        return errorToast("Failed to add employee");
      }

      if (values.employeeTypeId === 1 && isUserOnRAP360Program) {
        await sendApprenticeApplicationDocument(employee.employeeId, values.email);
      }
      successToast(`Employee Added Successfully`);
      navigate(`/employees/${employee.employeeId}`);
    } catch (error) {
      setIsSaving(false);
      setStatus(STAUTES.IDLE);
      console.error("Error adding employee:", error);
      errorToast(error.message || "Failed to add employee");
    }
  };

  const fetchAllEthnicityTypes = async () => {
    const { data } = await postApi(GET_ALL_ETHNICITY_TYPES, defaultDropdownConfig);
    setEthnicity(data || []);
  };

  const fetchAllVeteranStatusTypes = async () => {
    const { data } = await postApi(GET_ALL_VETERAN_STATUS_TYPES, defaultDropdownConfig);
    setVeteranStatus(data || []);
  };

  const fetchAllRaceTypes = async () => {
    const { data } = await postApi(GET_ALL_RACE_TYPES, defaultDropdownConfig);
    setRace(data || []);
  };

  const fetchAllEducationLevelTypes = async () => {
    const { data } = await postApi(GET_ALL_EDUCATION_LEVEL_TYPES, defaultDropdownConfig);
    setEducationLevel(data || []);
  };

  const fetchAllDisabilityTypes = async () => {
    const { data } = await postApi(GET_ALL_DISABILITY_TYPES, defaultDropdownConfig);
    setDisability(data || []);
  };

  const fetchAllRAPInfo = async () => {
    const response = await getApi(RAP_INFOS_DROPDOWNS, defaultDropdownConfig);

    if (response.data) {
      // Transform based on actual structure
      const options = response.data.map(item => ({
        label: item.label || item.name, // Use the correct property name
        value: item.value || item.rapInfoId // Use the correct property name
      }));

      setRapPrograms(options);
    }
  };

  const fetchAllCareerConnectionTypes = async () => {
    const { data } = await postApi(GET_ALL_CAREER_CONNECTION_TYPES, defaultDropdownConfig);
    setCareerConnections(data || []);
  };

  const fetchAllLanguageType = async () => {
    const { data } = await postApi(GET_ALL_LANGUAGE_TYPES, defaultDropdownConfig);
    setLanguageType(data.map(item => ({ label: item.languageType, value: item.languageTypeId })));
  };

  const fetchAllNotificationType = async () => {
    const { data } = await postApi(GET_ALL_NOTIFICATION_TYPES, defaultDropdownConfig);
    setNotificationType(data.map(item => ({ label: item.notificationType, value: item.notificationTypeId })));
  };

  const fetchAllEmployeeStatusType = async () => {
    const { data } = await postApi(GET_ALL_EMPLOYEE_STATUS_TYPES, defaultDropdownConfig);
    setEmployeeStausType(data.map(item => ({ label: item.employeeStatusType, value: item.employeeStatusTypeId })));
  };

  const fetchAllEmployeeTermType = async () => {
    const { data } = await postApi(GET_ALL_EMPLOYEE_TERM, defaultDropdownConfig);
    setEmployeeTermType(data.map(item => ({ label: item.employmentTermType, value: item.employmentTermTypeId })));
  };

  const fetchAllFringePaymentMethod = async () => {
    const { data } = await postApi(GET_ALL_FRINGE_PAYMENT_METHOD, defaultDropdownConfig);
    setFringePaymentMethod(data.map(item => ({ label: item.fringePaymentMethodType, value: item.fringePaymentMethodTypeId })));
  };

  const fetchAllManager = async () => {
    const { data } = await postApi(GET_ALL_MANAGER_TYPES, defaultDropdownConfig);
    setManagerType(data.map(item => ({ label: item.employeeName, value: item.employeeId })));
  };

  const fetchAllApprenticeStatusTypes = async () => {
    const { data } = await postApi(GET_ALL_APPRENTICE_STATUS_TYPES, defaultDropdownConfig);
    setApprenticeStatuses(data || []);
  };

  const fetchAllRtiOptions = async () => {
    try {
      const { data } = await postApi(RAP_RTI_DROPDOWN, defaultDropdownConfig);
      if (Array.isArray(data)) {
        setRtiOptions(data.map(item => ({ label: item?.rtiName, value: item?.id })));
      } else {
        setRtiOptions([]);
      }
    } catch (error) {
      console.error("Failed to fetch RTI Options:", error);
      setRtiOptions([]);
    }
  };

  const getDropdownOptionsByType = (type, fringeBenefitData) => {
    const section = fringeBenefitData?.employeeFringeBenefitDropdownList?.find(item => item.fringeBenefitType === type);
    return (
      section?.employeeFringeBenefitAccounts?.map(account => ({
        value: account.fringeBenefitAccountId,
        label: account.planName
      })) || []
    );
  };

  const fetchFringeBenefits = async () => {
    const fringeBenefitData = await getApi(GET_CLIENT_FRINGE_BENEFITS);
    setHealthInsuranceOptions(getDropdownOptionsByType("Health Insurance", fringeBenefitData));
    setRetirementPensionOptions(getDropdownOptionsByType("Retirement/Pension", fringeBenefitData));
    setFringeBenefitDropdowns(fringeBenefitData?.employeeFringeBenefitDropdownList);
    setFringeBenefitCheckbox(fringeBenefitData?.employeeFringeBenefitSingle);
  };

  const handleCheckBoxChange = (e, index) => {
    const isChecked = e.target.checked;
    const updatedCheckboxes = [...fringeBenefitCheckbox];
    updatedCheckboxes[index].employeeFringeBenefitAccounts[0].isSelected = isChecked;
    setFringeBenefitCheckbox(updatedCheckboxes);
  };

  const handleHealthInsuranceSelect = selectedValue => {
    setFringeBenefitDropdowns(prev =>
      prev.map(item => {
        if (item.fringeBenefitType === fringeBenefitTypes.healthInsurance.label) {
          const updatedFringeBenefitDropdowns = item.employeeFringeBenefitAccounts.map(account => ({
            ...account,
            isSelected: account.fringeBenefitAccountId === selectedValue
          }));

          return {
            ...item,
            employeeFringeBenefitAccounts: updatedFringeBenefitDropdowns
          };
        }
        return item;
      })
    );
  };

  const handleRetirementPensionSelect = selectedValues => {
    const uniqueValues = Array.from(new Set(selectedValues?.map(opt => opt.value)));
    setFringeBenefitDropdowns(prev =>
      prev.map(item => {
        if (item.fringeBenefitType === fringeBenefitTypes.retirement.label) {
          const updatedFringeBenefitDropdowns = item.employeeFringeBenefitAccounts.map(account => ({
            ...account,
            isSelected: uniqueValues.includes(account.fringeBenefitAccountId)
          }));

          return {
            ...item,
            employeeFringeBenefitAccounts: updatedFringeBenefitDropdowns
          };
        }
        return item;
      })
    );
  };

  const convertToEmployeeFringeBenefitPayload = () => {
    const employeeFringeBenefit = [];
    fringeBenefitDropdowns.forEach(item => {
      item.employeeFringeBenefitAccounts.forEach(account => {
        const { planName, ...rest } = account;
        employeeFringeBenefit.push(rest);
      });
    });

    fringeBenefitCheckbox.forEach(item => {
      const { planName, ...rest } = item.employeeFringeBenefitAccounts[0];
      employeeFringeBenefit.push(rest);
    });

    return employeeFringeBenefit;
  };

  useEffect(() => {
    fetchAllLanguageType();
    fetchAllNotificationType();
    fetchAllEmployeeStatusType();
    fetchAllEmployeeTermType();
    fetchAllFringePaymentMethod();
    fetchAllManager();
    fetchAllEthnicityTypes();
    fetchAllVeteranStatusTypes();
    fetchAllRaceTypes();
    fetchAllEducationLevelTypes();
    fetchAllDisabilityTypes();
    fetchAllRAPInfo();
    fetchAllCareerConnectionTypes();
    fetchAllApprenticeStatusTypes();
    fetchAllRtiOptions();
    fetchFringeBenefits();
    onEdit();
  }, [id]);

  useEffect(() => {
    handleHealthInsuranceSelect(healthInsurance);
  }, [healthInsurance]);

  useEffect(() => {
    handleRetirementPensionSelect(retirementPension);
  }, [retirementPension]);

  const defaultFormProps = { control, formValues: employeeProfileData, handleReadValueClick };
  return (
    <div className="partner-profile">
      <ProFormsLayout
        status={status}
        backAction={backAction}
        title={"Add Employee"}
        backLabel="Go Back to All Employees"
        beingEdited={isEditModeOn}
        onEdit={onEdit}
        isSaving={isSaving}
        canView={profilePermission}
        hideEdit={
          !(
            employeeBasicInfo.canEdit ||
            employeeApprenticeInfo.canEdit ||
            employeeAddressInfo.canEdit ||
            employeeMailingAddressInfo.canEdit ||
            employeeAdditionalInfo.canEdit
          )
        }
        onCancel={onCancel}
        onSave={handleSubmit(onSubmit)}
      >
        {!isLoading ? (
          <>
            {employeeBasicInfo.canView && (
              <FormSectionWrapper title={"BASIC INFORMATION"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employeeStatusTypeGuid}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.employeeStatusTypeGuid.perKey]}
                  options={employeeStausType}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.internalEmployeeId}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.internalEmployeeId.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.jobTitle} permission={employeeBasicInfo.fieldPerObj[formConfig.jobTitle.perKey]} />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.firstName}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.firstName.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.middleName}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.middleName.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.lastName} permission={employeeBasicInfo.fieldPerObj[formConfig.lastName.perKey]} />
                <ProMobileField
                  {...defaultFormProps}
                  {...formConfig.cellPhone}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.cellPhone.perKey]}
                />
                <ProMobileField
                  {...defaultFormProps}
                  {...formConfig.officePhone}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.officePhone.perKey]}
                />
                <ProMobileField
                  {...defaultFormProps}
                  {...formConfig.whatsApp}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.whatsApp.perKey]}
                />
                <ProEmailField {...defaultFormProps} {...formConfig.email} permission={employeeBasicInfo.fieldPerObj[formConfig.email.perKey]} />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.department}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.department.perKey]}
                />
                <ProSSNField
                  {...defaultFormProps}
                  {...formConfig.last4ofSSN}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.last4ofSSN.perKey]}
                  isLast4={true}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.birthDate}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.birthDate.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.sex}
                  options={sexOptions}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.sex.perKey]}
                />
                <ProFileUploadField
                  {...defaultFormProps}
                  {...formConfig.profilePictureFile}
                  inputProps={{ accept: "image/*" }}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.profilePictureFile.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.yearsOfExperience}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.yearsOfExperience.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employeeTypeId}
                  // TODO: Get the options from api call
                  options={[
                    { label: "Apprentice", value: 1 },
                    { label: "Mentor", value: 2 },
                    { label: "Journeyman", value: 3 },
                    { label: "Apprentice Prospect", value: 4 },
                    { label: "Journey Worker Helper", value: 5 }
                  ]}
                  // TODO: Do the permissions for this
                  //permission={employeeApprenticeInfo.fieldPerObj[formConfig.ethnicityTypeId.perKey]}
                  permission={employeeBasicInfo.fieldPerObj?.[formConfig.employeeTypeId.perKey] ?? { canView: true, canEdit: true }}
                />
              </FormSectionWrapper>
            )}

            {(employeeType === 1 || employeeType === 4) && employeeApprenticeInfo.canView && (
              <FormSectionWrapper title={"APPRENTICE INFORMATION"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.ethnicityTypeId}
                  options={ethnicity}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.ethnicityTypeId.perKey]}
                />
                <ProMultiSelectSelectField
                  {...defaultFormProps}
                  {...formConfig.veteranStatusTypeId}
                  options={veteranStatus}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.veteranStatusTypeId.perKey]}
                />
                <ProMultiSelectSelectField
                  {...defaultFormProps}
                  {...formConfig.raceTypeId}
                  options={race}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.raceTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.educationLevelTypeId}
                  options={educationLevel}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.educationLevelTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.disabilityTypeId}
                  options={disability}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.disabilityTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employmentStatus}
                  options={employmentStatusOptions}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.employmentStatus.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.rapInfoId}
                  options={rapPrograms}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.rapInfoId.perKey]}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.dateApprenticeshipBegins}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.dateApprenticeshipBegins.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.careerConnectionTypeId}
                  options={careerConnections}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.careerConnectionTypeId.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.anyCredit}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.anyCredit.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.rti}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.rti.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.apprenticeStatusTypeId}
                  options={apprenticeStatuses}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.apprenticeStatusTypeId.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.apprenticeshipRegNumber}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.apprenticeshipRegNumber.perKey]}
                />
                {employeeType === 4 && (
                  <ProSelectField
                    {...defaultFormProps}
                    {...formConfig.apprenticeProspectStatusTypeId}
                    permission={employeeApprenticeInfo.fieldPerObj[formConfig.apprenticeProspectStatusTypeId.perKey]}
                  />
                )}
              </FormSectionWrapper>
            )}
            {employeeAddressInfo.canView && (
              <FormSectionWrapper title={"ADDRESS INFORMATION"}>
                <ProTextInput {...defaultFormProps} {...formConfig.address} permission={employeeAddressInfo.fieldPerObj[formConfig.address.perKey]} />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.address2}
                  permission={employeeAddressInfo.fieldPerObj[formConfig.address2.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.city} permission={employeeAddressInfo.fieldPerObj[formConfig.city.perKey]} />
                <ProTextInput {...defaultFormProps} {...formConfig.state} permission={employeeAddressInfo.fieldPerObj[formConfig.state.perKey]} />
                <ZipField {...defaultFormProps} {...formConfig.zip} permission={employeeAddressInfo.fieldPerObj[formConfig.zip.perKey]} />
              </FormSectionWrapper>
            )}
            {employeeMailingAddressInfo.canView && (
              <FormSectionWrapper title={"MAILING ADDRESS INFORMATION"}>
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingAddress}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingAddress.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingState}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingState.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingCity}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingCity.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingZip}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingZip.perKey]}
                />
              </FormSectionWrapper>
            )}
            {employeeAdditionalInfo.canView && (
              <FormSectionWrapper title={"ADDITIONAL INFORMATION"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.fringePaymentMethodType}
                  options={fringePaymentMethod}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.fringePaymentMethodType.perKey]}
                />
                <ProCurrencyField
                  {...defaultFormProps}
                  {...formConfig.hourlyRateAmount}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.hourlyRateAmount.perKey]}
                />
                <ProCurrencyField
                  {...defaultFormProps}
                  {...formConfig.fringeRateAmount}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.fringeRateAmount.perKey]}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.startDate}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.startDate.perKey]}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.endDate}
                  fieldProps={{ minDate: watch("startDate") }}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.endDate.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.manager}
                  options={managerType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.manager.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.languageType}
                  options={languageType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.languageType.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.notificationType}
                  options={notificationType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.notificationType.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employmentTermTypeId}
                  options={employeeTermType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.employmentTermTypeId.perKey]}
                />
                <ToggleField {...defaultFormProps} {...formConfig.isUnion} permission={employeeAdditionalInfo} />
              </FormSectionWrapper>
            )}
            {!isUnion && (
              <FormSectionWrapper title={"FRINGE BENEFITS (NON-UNION)"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.healthInsuranceId}
                  options={healthInsuranceOptions}
                  permission={fieldTruePermission}
                />
                <ProMultiSelectSelectField
                  {...defaultFormProps}
                  {...formConfig.retirementPensionId}
                  options={retirementPensionOptions.filter(
                    opt => isOptionNotSelected(opt, retirementPension)
                  )}
                  permission={fieldTruePermission}
                  value={
                    (Array.isArray(retirementPension)
                      ? Array.from(
                          new Map(retirementPension.map(item => [item.value, item])).values()
                        )
                      : [])
                  }
                  onChange={selectedValues => {
                    const uniqueValues = Array.from(
                      new Map(selectedValues.map(item => [item.value, item])).values()
                    );
                    setValue("retirementPensionId", uniqueValues);
                    handleRetirementPensionSelect(uniqueValues);
                  }}
                />
                <InputWrapper size={4}></InputWrapper>
                <Box display="flex" flexDirection="row" flexWrap="nowrap" gap={1} bgcolor="#f5f5f5" p={1} m={2} borderRadius={1} width="100%">
                  {fringeBenefitCheckbox?.map((checkbox, index) => (
                    <ProCheckbox
                      fieldProps={{
                        checked: checkbox?.employeeFringeBenefitAccounts[0]?.isSelected || false,
                        onChange: e => handleCheckBoxChange(e, index)
                      }}
                      control={control}
                      formValues={{
                        [`checkbox${index + 1}`]: checkbox?.employeeFringeBenefitAccounts[0]?.isSelected || false
                      }}
                      name={`checkbox${index + 1}`}
                      label={checkbox?.employeeFringeBenefitAccounts[0].planName}
                      permission={fieldTruePermission}
                    />
                  ))}
                </Box>
              </FormSectionWrapper>
            )}
          </>
        ) : (
          <Loading></Loading>
        )}
      </ProFormsLayout>
    </div>
  );
}
